import React, {
  useState,
  useEffect,
  FC,
  useCallback,
  useRef,
  Children,
} from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Content from "../../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Alert,
} from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../../components/Component";
// import PurchaseOrderAside from "./PurchaseOrderAside";
import { FormProvider, set, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  ClockCircleOutlined,
  SmileTwoTone,
  MehOutlined,
  FileTextOutlined,
  SyncOutlined,
  ExclamationCircleTwoTone,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  TrophyOutlined,
  BookOutlined,
  CheckOutlined,
  FormOutlined,
  UnorderedListOutlined,
  UploadOutlined,
  CloseOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Popover,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  Modal as AntModal,
  Drawer,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Tag,
  Popconfirm,
  Checkbox,
  Timeline,
} from "antd";
import FormSelect from "../../form-components/SelectComponent";
import FormInput from "../../form-components/InputComponent";
import FormDatePicker from "../../form-components/DatePicker";
import misc from "../../../api/misc/dropDowns";
// import EditPoModal from "./EditPoModal";
import Swal from "sweetalert2";
import CropperComponent from "../../components/CropperComponent";
// import SignatureModal from "./SignatureModal";
import dayjs from "dayjs";
// import QuotationApprovalDrawer from "./QuotationApprovalDrawer";
// import ChangeFromBuyerModal from "./ChangeFromBuyerModal";
// import statusMapper from "./StatusMapper";
import axios from "axios";
import { useSelector } from "react-redux";
import { formatCurrency, formatDecimal } from "../../../utils/Utils";
// import PdfGenerator from "./TestPDF";
import { RootState } from "../../../store/store";
import { useDispatch } from "react-redux";
import { ReactTyped } from "react-typed";
import { title } from "process";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import tenderApis from "../../../api/tender/tenderApis";
const { Panel } = AntCollapse;

interface SelectOptions {
  label: string;
  value: string;
}

type Cess = {
  cessName: string;
  cessType?: string;
  cessPercentage?: string;
  cessAmount?: string;
};
interface TaxConfiguration {
  taxType: string;
  gstType?: string; //IGST or CGST+SGST
  cess?: Cess[];
}

interface CurrencyData {
  description: string;
  currency_code: string;
  currency_symbol: string;
  currency_format: string;
  example: string;
}

export const GetTenderStatusTag = ({ status }: any) => {
  const statusMap: Record<
    string,
    {
      color: string;
      label: string;
      icon: React.ReactNode;
    }
  > = {
    "New Tender": {
      color: "blue",
      label: "New Tender",
      icon: <ClockCircleOutlined />,
    },
    Interested: {
      color: "cyan",
      label: "Interested",
      icon: <SmileTwoTone twoToneColor="#13c2c2" />,
    },
    "Not Interested": {
      color: "default",
      label: "Not Interested",
      icon: <MehOutlined />,
    },
    Responded: {
      color: "purple",
      label: "Responded",
      icon: <FileTextOutlined />,
    },
    Published: {
      color: "cyan",
      label: "Published",
      icon: <BookOutlined />,
    },
    Draft: {
      color: "geekblue",
      label: "Draft",
      icon: <ClockCircleOutlined />,
    },
    Negotiation: {
      color: "orange",
      label: "Negotiation",
      icon: <SyncOutlined />,
    },
    "Pending Approval": {
      color: "gold",
      label: "Pending Approval",
      icon: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
    },
    Approved: {
      color: "green",
      label: "Approved",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    },
    Awarded: {
      color: "orange",
      label: "Awarded",
      icon: <TrophyOutlined twoToneColor="orange" />,
    },
    Evaluated: {
      color: "green",
      label: "Evaluated",
      icon: <SyncOutlined />,
    },
    "Under Evaluation": {
      color: "purple",
      label: "Under Evaluation",
      icon: <FileTextOutlined />,
    },
  };

  const tagData = statusMap[status] || {
    color: "default",
    label: status,
    icon: <FileTextOutlined />,
  };

  return (
    <Tag
      icon={tagData.icon}
      color={tagData.color}
      style={{
        fontSize: 14,
      }}
      className="px-2"
    >
      {tagData.label}
    </Tag>
  );
};
const ViewTenderDetails: FC<any> = () => {
  const [mode, setMode] = useState("view");
  const [itemsCurrentPage, setItemsCurrentPage] = useState(1);
  const [itemsPageSize, setItemsPageSize] = useState(10);
  const location = useLocation();
  const { tenderId, screenName, status } = location.state;
  const [tenders, setTenders] = useState([]);
  const dispatch = useDispatch();

  const [popupCol, setPopupCol] = useState<string>("");

  const [openPricingInfoPopUp, setOpenPricingInfoPopUp] = useState<
    null | number
  >(null);
  const [editPriceInfo, setEditPriceInfo] = useState<boolean>(false);

  const [openServicePricingInfoPopUp, setOpenServicePricingInfoPopUp] =
    useState<null | number>(null);
  const [editServicePriceInfo, setEditServicePriceInfo] =
    useState<boolean>(false);

  const [openPlanningSchedulePopUp, setOpenPlanningSchedulePopUp] = useState<
    null | number
  >(null);
  const [editPlanningSchedule, setEditPlanningSchedule] =
    useState<boolean>(false);

  const [openProductionSchedulesPopUp, setOpenProductionSchedulesPopUp] =
    useState<null | number>(null);
  const [editProductionSchedules, setEditProductionSchedules] =
    useState<boolean>(false);

  const [openShipmentSchedulesPopUp, setOpenShipmentSchedulesPopUp] = useState<
    null | number
  >(null);
  const [editShipmentSchedules, setEditShipmentSchedules] =
    useState<boolean>(false);

  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [notes, setNotes] = useState<{ text: string; date: string; user: string }[]>([
    { text: "Tender published and sent to all registered suppliers.", date: "2025-07-20 09:00 AM", user: "Aida Rahman" },
    { text: "2 clarification queries received from suppliers. Responses issued.", date: "2025-07-25 02:30 PM", user: "Zul Ariffin" },
  ]);
  const [newNote, setNewNote] = useState("");
  const [notesDrawerOpen, setNotesDrawerOpen] = useState(false);

  const pdfBlobData: any = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shareOptionsToggle, setShareOptionsToggle] = useState(false);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );

  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [activeTab, setActiveTab] = useState<string>("");
  const [TabsList, setTabsList] = useState<
    {
      tabKey: string;
      label: string;
    }[]
  >([
    // {
    //   tabKey: "activityInformation",
    //   label: "Activity Information",
    // },
    // {
    //   tabKey: "allocateMaterials",
    //   label: "Allocate Materials",
    // },
    // {
    //   tabKey: "allocateResources",
    //   label: "Allocate Resource",
    // },
  ]);

  const [questioners, setQuestioners] = useState<any>({});

  const [disableDiscard, setDisableDiscard] = useState(false);

  const [disableApprove, setDisableApprove] = useState(false);
  const [disableReject, setDisableReject] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>();
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [disapprovePO, setDisapprovePO] = useState<boolean>(false);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [poStatus, setPoStatus] = useState<any>("");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [taxConfiguration, setTaxConfiguration] = useState<TaxConfiguration>();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>([]);
  const [attachments, setAttachments] = useState<any>([]);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [signature, setSignature] = useState<any>([]);
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [allCurrencyData, setAllCurrencyData] = useState<CurrencyData[]>([]);
  const [currency, setCurrency] = useState<CurrencyData>({
    description: "",
    currency_code: "",
    currency_symbol: "",
    currency_format: "",
    example: "",
  });
  const typeConfigMap: any = {
    "Yes/No": {
      color: "green",
      icon: (
        <>
          {<CheckOutlined />}/{<CloseOutlined />}
        </>
      ),
    },
    "Single Choice": {
      color: "blue",
      icon: <CheckCircleOutlined />,
    },
    "Long Text": {
      color: "orange",
      icon: <FormOutlined />,
    },
    "Short Text": {
      // New entry for Short Text
      color: "cyan", // Light blue color
      icon: <EditOutlined />, // Or <MessageOutlined />
    },
    "Multiple Choice": {
      color: "purple",
      icon: <UnorderedListOutlined />,
    },
    "File Upload": {
      color: "gray",
      icon: <UploadOutlined />,
    },
  };
  const [uomOptions, setUomOptions] = useState<SelectOptions[]>([]);
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState<SelectOptions[]>([]);
  const [materialOptions, setMaterialOptions] = useState<SelectOptions[]>([]);
  const [DMS, setDMS] = useState<any>([]);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [changeFromBuyerData, setChangeFromBuyerData] = useState<any>();
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const apiResponse: any = await tenderApis.getTenderById(tenderId);
      const CurrentTender = apiResponse?.data;

      if (!CurrentTender) {
        setIsLoading(false);
        return;
      }

      const resetFormObj: any = {};

      setOriginalData(CurrentTender);

      // Set material or task data based on tenderFor
      if (CurrentTender.tenderFor === "Material") {
        setMaterialData(CurrentTender.materials || []);
      } else {
        setMaterialData(CurrentTender.tasks || []);
      }

      setPoStatus(CurrentTender?.status);

      // Separate documents into Instructions, T&C, and regular attachments
      const allDocs = CurrentTender?.documents || [];
      const instructionsDoc = allDocs.find(
        (doc: any) => doc.moduleFileType === "Instructions"
      );
      const termsDoc = allDocs.find(
        (doc: any) => doc.moduleFileType === "TermsAndConditions"
      );
      const regularAttachments = allDocs.filter(
        (doc: any) =>
          doc.moduleFileType !== "Instructions" &&
          doc.moduleFileType !== "TermsAndConditions"
      );
      setAttachments(regularAttachments);

      // Fetch Instructions HTML content
      if (instructionsDoc?.filePath) {
        try {
          const res = await fetch(instructionsDoc.filePath);
          const text = await res.text();
          setInstructions(text);
        } catch (err) {
          console.error("Failed to fetch instructions:", err);
          setInstructions("");
        }
      } else {
        setInstructions("");
      }

      // Fetch Terms and Conditions HTML content
      if (termsDoc?.filePath) {
        try {
          const res = await fetch(termsDoc.filePath);
          const text = await res.text();
          setTermsAndConditions(text);
        } catch (err) {
          console.error("Failed to fetch terms:", err);
          setTermsAndConditions("");
        }
      } else {
        setTermsAndConditions("");
      }

      // Transform questionnaire sections from API
      const sections = CurrentTender?.questionnaireSections;
      if (sections && sections.length > 0) {
        const questioner: any = {};
        const tabsList: { tabKey: string; label: string }[] = [];

        sections.forEach((item: any) => {
          const questionerSectionId = item?.sectionName.replace(/\s/g, "");
          tabsList.push({
            tabKey: questionerSectionId,
            label: item.sectionName + " (" + item.weightage + "%)",
          });
          questioner[`${questionerSectionId}`] = {
            sectionName: item.sectionName,
            totalWeightage: item.weightage,
            SectionApprovals: (item.evaluators || []).map((ev: any) => ({
              name: ev.userName,
              type: "Evaluator",
              role: ev.submissionStatus === "submitted" ? "Submitted" : "Not Submitted",
              status: ev.submissionStatus === "submitted" ? "Approved" : "Pending",
            })),
          };
          const Questions: any = [];
          item.questions?.forEach((question: any, index: any) => {
            Questions.push({
              questionId: questionerSectionId + "--" + index,
              description: question.question,
              type: question.type,
              weightage: question.weightage,
              choiceOptions: question.options || [],
            });
          });
          questioner[`${questionerSectionId}`].questions = Questions;
        });

        setQuestioners(questioner);
        setTabsList(tabsList);
        setActiveTab(tabsList[0].tabKey);
      }

      reset(resetFormObj);
      setShowSubmitBtm(false);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const ShowAddressPopOver = ({ address }: any) => {
    return (
      <ul>
        <li>{address.addressLine1}</li>
        <li>{address.addressLine2}</li>
        <li>
          {address.city}, {address.stateName}, {address.countryName} -{" "}
          {address.pincode}
        </li>
      </ul>
    );
  };

  const expandableConfig = {
    expandedRowRender: (record: any) => {
      return (
        <div className="expandableBody">
          <div style={{ flex: 1, textAlign: "left" }}>
            {record?.choiceOptions?.length > 0 && (
              <>
                <p style={{ margin: 0 }}>Options</p>
                <ul className="list-group mb-3">
                  {record.choiceOptions.map((option: any, index: any) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>{option}</span>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      );
    },
    rowExpandable: (record: any) =>
      record.type === "Single Choice" || record.type === "Multiple Choice",
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [tenderId]);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const rejectTender = async (rejectedReason: string) => {
    try {
      const response = await tenderApis.rejectPublish(tenderId, {
        reason: rejectedReason,
      });
      if (response?.status || response?.data) {
        Swal.fire("Rejected", "Tender has been rejected.", "success");
        navigate("/tender/tender-list");
      } else {
        Swal.fire("Error", response?.message || "Failed to reject tender", "error");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Failed to reject tender", "error");
    }
    setDisableReject(false);
  };

  const ApproveTender = async () => {
    try {
      const response = await tenderApis.approvePublish(tenderId, {});
      if (response?.status || response?.data) {
        Swal.fire("Success", "Tender has been approved.", "success");
        navigate("/tender/tender-list");
      } else {
        Swal.fire("Error", response?.message || "Failed to approve tender", "error");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Failed to approve tender", "error");
    } finally {
      setDisableApprove(false);
    }
  };

  const PublishTender = async () => {
    try {
      const response = await tenderApis.publishTender(tenderId);
      if (response?.status || response?.data) {
        Swal.fire("Published", "Tender has been published successfully.", "success");
        navigate("/tender/tender-list");
      } else {
        Swal.fire("Error", response?.message || "Failed to publish tender", "error");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Failed to publish tender", "error");
    } finally {
      setDisableApprove(false);
    }
  };

  useEffect(() => {
    if (disapprovePO == false) {
      setDisableReject(false);
    }
  }, [disapprovePO]);

  const configColumns = ({
    OriginalData,
    materialData,
    mode,
  }: {
    OriginalData: any;
    materialData: any;
    mode: string;
  }) => {
    const category = OriginalData?.tenderFor;
    if (category == "Material") {
      return [
        {
          title: "S.No.",
          dataIndex: "lineNo",
          key: "lineNo",
          align: "center",
          width: 50,
          fixed: "left",
          render: (text: any, record: any, index: any) => {
            return (itemsCurrentPage - 1) * itemsPageSize + index + 1;
          },
        },
        {
          title: "Category",
          dataIndex: "categoryName",
          key: "categoryName",
          width: 250,
          render: (text: any, record: any) =>
            text || record?.materialCategoryName || "--",
        },
        {
          title: "Material Name",
          dataIndex: "materialName",
          key: "materialName",
          fixed: "left",
          width: 220,
        },
        {
          title: "Material Usage",
          dataIndex: "usage",
          key: "usage",
          width: 220,
          ellipsis: true,
          render: (text: any, record: any) => {
            const val = text || record?.materialUsage || "--";
            const MAX_LEN = 30;
            if (val !== "--" && val.length > MAX_LEN) {
              return (
                <Tooltip title={val}>
                  <span style={{ cursor: "pointer" }}>
                    {val.slice(0, MAX_LEN)}…{" "}
                    <InfoCircleOutlined style={{ color: "#8c8c8c", fontSize: 11 }} />
                  </span>
                </Tooltip>
              );
            }
            return val;
          },
        },
        {
          title: "QTY",
          dataIndex: "quantity",
          key: "quantity",
          width: 150,
          render: (text: any, record: any) => (
            <span>
              {Number(text).toFixed(2)} {record?.uomName || record?.uomLabel || ""}
            </span>
          ),
        },
        {
          title: "Installation Required",
          dataIndex: "isInstallationRequired",
          key: "isInstallationRequired",
          width: 150,
          render: (value: any) => (value ? "Yes" : "No"),
        },
        {
          title: "Installation Charges",
          dataIndex: "totalInstallationCharges",
          key: "totalInstallationCharges",
          width: 160,
          render: (value: any) =>
            value != null && value !== 0
              ? Number(value).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })
              : "--",
        },
        {
          title: "Tower / Block",
          dataIndex: "unitName",
          key: "unitName",
          width: 150,
          render: (text: any) => text || "--",
        },
        {
          title: "Floor",
          dataIndex: "floorNo",
          key: "floorNo",
          width: 100,
          render: (text: any) => text || "--",
        },
        {
          title: "Flat",
          dataIndex: "subUnitName",
          key: "subUnitName",
          width: 100,
          render: (text: any) => text || "--",
        },
        {
          title: "NEED BY DATE",
          dataIndex: "needByDate",
          key: "needByDate",
          width: 150,
          render: (text: any) => {
            return text ? dayjs(text).format("DD-MM-YYYY") : "--";
          },
        },
      ];
    }
    return [
      {
        title: "#",
        dataIndex: "lineNo",
        key: "lineNo",
        width: 60,
        fixed: "left",
        render: (text: any, record: any, index: any) => {
          return (itemsCurrentPage - 1) * itemsPageSize + index + 1;
        },
      },
      {
        title: "Task Title",
        dataIndex: "taskTitle",
        key: "taskTitle",
        fixed: "left",
        width: 250,
      },
      {
        title: "Task Usage",
        dataIndex: "taskUsage",
        key: "taskUsage",
        width: 200,
        render: (text: any, record: any) => text || record?.usage || "--",
      },
      {
        title: "Work Category",
        dataIndex: "workCategoryName",
        key: "workCategoryName",
        width: 200,
      },
      {
        title: "QTY",
        dataIndex: "quantity",
        key: "quantity",
        width: 120,
        render: (text: any, record: any) => (
          <span>
            {Number(text).toFixed(2)} {record?.uomName || record?.uom || ""}
          </span>
        ),
      },
      {
        title: "Installation Required",
        dataIndex: "installationRequired",
        key: "installationRequired",
        width: 150,
        render: (value: any) => (value ? "Yes" : "No"),
      },
      {
        title: "Tower / Block",
        dataIndex: "siteStructureUnitName",
        key: "siteStructureUnitName",
        width: 150,
        render: (text: any) => text || "--",
      },
      {
        title: "Floor",
        dataIndex: "floorNo",
        key: "floorNo",
        width: 100,
        render: (text: any) => text || "--",
      },
      {
        title: "Flat",
        dataIndex: "siteStructureSubUnitName",
        key: "siteStructureSubUnitName",
        width: 100,
        render: (text: any) => text || "--",
      },
    ];
  };

  if (isLoading)
    return (
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin
          indicator={<LoadingOutlined spin />}
          className="m-auto"
          size="large"
        />
      </Flex>
    );

  let NeedByDate = "";
  let DeliveryAddress;
  if (OriginalData?.isLineLevelDelivery) {
    DeliveryAddress = "Line Level";
  } else if (OriginalData?.deliveryAddress) {
    DeliveryAddress = OriginalData.deliveryAddress;
  }

  const SiteAddress = OriginalData?.siteName || "";

  const ApprovalTimelineContent = () => {
    const approvalsData = OriginalData?.publishApprovals;
    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.approvalStatus === "Approved";
              const isRejected = approval.approvalStatus === "Rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName} - {approval?.approvalStage}
                  <div className="designation">{approval?.level}</div>
                  {approval?.approvedDate && (
                    <div className="designation">
                      {dayjs(approval?.approvedDate).format("DD-MMM-YYYY hh:mm A")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <span
          style={{
            color: "#2263b3",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 500,
            fontSize: 15,
          }}
        >
          Yes
        </span>
      </Popover>
    );
  };

  const SectionApprovalsContent = ({ OriginalData }: any) => {
    const approvalsData = OriginalData?.SectionApprovals;
    console.log("approvalsData::Secton", OriginalData);

    // If there's no approval data or it's an empty array, return the "No" badge
    if (!approvalsData || approvalsData.length === 0) {
      // Assuming Badge is Ant Design's Tag, use it appropriately
      // If you have a custom Badge component, use that
      return <Tag color="error">No</Tag>; // Using Ant Design Tag for "No"
      // return <Badge color="outline-danger">No</Badge>; // If your Badge is custom
    }

    // Content for the Popover
    const popoverContent = (
      <Timeline className="approval-timeline">
        {approvalsData.map((approval: any, index: any) => {
          const isApproved = approval.status === "Approved";
          const isRejected = approval.status === "Rejected";
          return (
            <Timeline.Item
              key={index}
              dot={
                isApproved ? (
                  <CheckCircleOutlined style={{ color: "green" }} />
                ) : isRejected ? (
                  <CloseCircleOutlined style={{ color: "red" }} />
                ) : undefined
              }
            >
              {approval?.name} - {approval?.type}
              <div className="designation">{approval?.role}</div>
              {approval?.dateTime && (
                <div className="designation">
                  {dayjs(approval?.dateTime).format("DD-MMM-YYYY hh:mm A")}
                </div>
              )}
            </Timeline.Item>
          );
        })}
      </Timeline>
    );

    return (
      <Popover
        content={popoverContent}
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <span
          style={{
            color: "#2263b3",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 500,
            fontSize: 15,
          }}
        >
          Yes
        </span>
      </Popover>
    );
  };

  const EvaluatedApprovalTimelineContent = () => {
    const approvalsData = OriginalData?.evaluationApprovals;
    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.approvalStatus === "Approved";
              const isRejected = approval.approvalStatus === "Rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName} - {approval?.approvalStage}
                  <div className="designation">{approval?.level}</div>
                  {approval?.approvedDate && (
                    <div className="designation">
                      {dayjs(approval?.approvedDate).format("DD-MMM-YYYY hh:mm A")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <span
          style={{
            color: "#2263b3",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 500,
            fontSize: 15,
          }}
        >
          Yes
        </span>
      </Popover>
    );
  };
  return (
    <>
      <Head title="View Tender" />
      <RejectPo
        isModalVisible={disapprovePO}
        setIsModalVisible={setDisapprovePO}
        rejectTender={rejectTender}
      />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>
                        {OriginalData?.tenderNumber || tenderId} |{" "}
                        <GetTenderStatusTag status={status || ""} />
                        {" "}
                      </span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <div className="d-flex">
                    {["Pending Approval"].includes(
                      OriginalData?.status || ""
                    ) &&
                      !showSubmitBtm &&
                      (() => {
                        const isAdmin = ["admin", "Admin", "ADMIN"].includes(currentUser?.orgRole || "") || ["admin", "Admin", "ADMIN"].includes(currentUser?.genericRole || "");
                        if (isAdmin) return true;
                        const currentUserId = currentUser?.id || currentUser?.userId;
                        return (OriginalData?.publishApprovals || []).some(
                          (a: any) => Number(a.userId) === Number(currentUserId) && a.approvalStatus === "Pending"
                        );
                      })() && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            <li>
                              {disableApprove ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  type="button"
                                  size="sm"
                                  onClick={() => {
                                    setDisableApprove(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to send your interest?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, send it!",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        ApproveTender();
                                      } else {
                                        setDisableApprove(false);
                                      }
                                    });
                                  }}
                                >
                                  Approve
                                </Button>
                              )}
                            </li>
                            <li>
                              {disableReject ? (
                                <Button color="danger" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => {
                                    setDisableReject(true);
                                    setDisapprovePO(true);
                                  }}
                                  type="button"
                                  className="btn-dim btn btn-secondary"
                                >
                                  Reject
                                </Button>
                              )}
                            </li>
                          </ul>
                        </div>
                      )}

                    {["Approved"].includes(OriginalData?.status || "") && (
                      <div className="actions clearfix">
                        <ul
                          className="m-auto d-flex align-items-center justify-content-center p-0"
                          style={{
                            flexDirection: "row-reverse",
                          }}
                        >
                          <li>
                            {disableApprove ? (
                              <Button color="primary" type="button">
                                <Spinner size="sm" color="light" />
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                type="button"
                                size="sm"
                                onClick={() => {
                                  setDisableApprove(true);
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to Publish?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, Publish!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      PublishTender();
                                    } else {
                                      setDisableApprove(false);
                                    }
                                  });
                                }}
                              >
                                Publish
                              </Button>
                            )}
                          </li>
                        </ul>
                      </div>
                    )}

                    {status === "Published" && (
                      <ul className="nk-ibx-head-tools g-1 m-0 p-0" style={{ listStyle: "none", display: "flex", alignItems: "center" }}>
                        <li>
                          {/* <Button
                            className="toggle"
                            color="warning"
                            size="sm"
                            onClick={() => setNotesDrawerOpen(true)}
                          >
                            <EditOutlined style={{ marginRight: 4 }} />
                            <span>Notes ({notes.length})</span>
                          </Button> */}
                        </li>
                      </ul>
                    )}

                    {!showSubmitBtm && (
                      <ul className="nk-ibx-head-tools g-1 m-0 p-0 ">
                        <li>
                          <Button
                            className="toggle"
                            color="primary"
                            size="sm"
                            onClick={async () => {
                              navigate("/tender/tender-list");
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </li>
                        {["Draft"].includes(OriginalData?.status || "") && (
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-v"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  <li
                                    className={mode == "edit" ? "active" : ""}
                                  >
                                    <DropdownItem
                                      tag="a"
                                      href="#tableView"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        navigate("/tender/new-tender", {
                                          state: { draftId: tenderId },
                                        });
                                      }}
                                    >
                                      <span>Edit</span>
                                    </DropdownItem>
                                  </li>
                                  {/* <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#ganttView"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                    >
                                      <span>option2</span>
                                    </DropdownItem>
                                  </li> */}
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        )}
                      </ul>
                    )}
                  </div>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Alert
                isOpen={OriginalData?.status === "Not Interested"}
                color="danger"
                className="start-0 w-100 py-1 mt-1"
                style={{
                  top: 0,
                  textAlign: "left",
                  fontSize: "14px",
                  cursor: "default",
                }}
              >
                <Tooltip title={OriginalData?.notInterestedReason}>
                  <span
                    className="fw-bold"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    View Reason,
                  </span>
                </Tooltip>{" "}
                <ReactTyped
                  strings={[
                    " As you are not interested in this tender, you can no longer make any actions.",
                  ]}
                  typeSpeed={5}
                  showCursor={false}
                />
              </Alert>

              <AntCollapse defaultActiveKey={["1", "2", "3", "4"]}>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>General Details</>
                    </div>
                  }
                  key="1"
                >
                  <div className="p-0">
                    <Descriptions
                      title={undefined}
                      className="custom-description-title ps-1"
                    >
                      <Descriptions.Item label="Tender">
                        {OriginalData?.tenderTitle}
                      </Descriptions.Item>
                      <Descriptions.Item label="Type">
                        {
                          <Tag
                            color={
                              OriginalData?.tenderType === "Open"
                                ? "green"
                                : "blue"
                            }
                          >
                            {OriginalData?.tenderType}
                          </Tag>
                        }
                      </Descriptions.Item>
                      <Descriptions.Item label="Tender Description">
                        <Tooltip title={OriginalData?.description}>
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 700,
                              display: "inline-block",
                            }}
                          >
                            {OriginalData?.description}
                          </span>
                        </Tooltip>
                      </Descriptions.Item>
                      <Descriptions.Item label="Tender For">
                        {
                          <Tag
                            color={
                              OriginalData?.tenderFor === "Material"
                                ? "purple"
                                : "cyan"
                            }
                          >
                            {OriginalData?.tenderFor}
                          </Tag>
                        }
                      </Descriptions.Item>
                      <Descriptions.Item label="Site / Project Name">
                        {OriginalData?.siteName}
                      </Descriptions.Item>
                      <Descriptions.Item label=" Selected Suppliers / Contractors">
                        {(() => {
                          const suppliers = OriginalData?.suppliers || [];
                          const contractors = OriginalData?.contractors || [];
                          const all = [
                            ...suppliers.map((s: any) => ({
                              name: s.supplierName,
                              status: s.invitationStatus || "--",
                            })),
                            ...contractors.map((c: any) => ({
                              name: c.contractorName,
                              status: c.invitationStatus || "--",
                            })),
                          ];
                          if (all.length === 0) return "--";
                          return (
                            <Popover
                              trigger="hover"
                              placement="bottom"
                              content={
                                <div style={{ maxHeight: 300, overflowY: "auto", width: 400 }}>
                                  <Table
                                    size="small"
                                    pagination={false}
                                    dataSource={all.map((item: any, idx: number) => ({ ...item, key: idx }))}
                                    columns={[
                                      {
                                        title: "Name",
                                        dataIndex: "name",
                                        key: "name",
                                      },
                                      {
                                        title: "Invitation Status",
                                        dataIndex: "status",
                                        key: "status",
                                        render: (text: string) => (
                                          <Tag color={text === "Accepted" ? "green" : text === "Rejected" ? "red" : text === "Pending" ? "orange" : "default"}>
                                            {text}
                                          </Tag>
                                        ),
                                      },
                                    ]}
                                  />
                                </div>
                              }
                              title={<span style={{ color: "#2263b3" }}>Suppliers / Contractors ({all.length})</span>}
                            >
                              <span
                                style={{
                                  color: "#2263b3",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                }}
                              >
                                View ({all.length})
                              </span>
                            </Popover>
                          );
                        })()}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last Submission Date">
                        {OriginalData?.lastSubmissionDate
                          ? dayjs(OriginalData.lastSubmissionDate).format("DD-MMM-YYYY")
                          : "--"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last Date For Expressing Interest">
                        {OriginalData?.lastDateForExpressingInterest
                          ? dayjs(OriginalData.lastDateForExpressingInterest).format("DD-MMM-YYYY")
                          : "--"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Evaluation Start Date">
                        {OriginalData?.evaluationStartDate
                          ? dayjs(OriginalData.evaluationStartDate).format(
                              "DD-MMM-YYYY hh:mm A"
                            )
                          : "--"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Sealed Bid Submission Date">
                        {OriginalData?.sealedBidSubmissionDate
                          ? dayjs(OriginalData.sealedBidSubmissionDate).format(
                              "DD-MMM-YYYY hh:mm A"
                            )
                          : "--"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Sealed Bid Postal Address">
                        {OriginalData?.sealedBidPostalAddress || "--"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Publish Approvals">
                        <ApprovalTimelineContent />
                      </Descriptions.Item>
                      <Descriptions.Item label="Evaluation Approvals">
                        <EvaluatedApprovalTimelineContent />
                      </Descriptions.Item>
                      <Descriptions.Item label="Total Invited">
                        {OriginalData?.totalInvited && OriginalData.totalInvited !== "N/A" ? OriginalData.totalInvited : 0}
                      </Descriptions.Item>
                      <Descriptions.Item label="Total Responded">
                        {OriginalData?.totalResponded && OriginalData.totalResponded !== "N/A" ? OriginalData.totalResponded : 0}
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>{OriginalData?.tenderFor === "Material" ? "Material Information" : "Work / Service Information"}</>
                    </div>
                  }
                  key="2"
                >
                  <div className="table-responsive poTable">
                    <div
                      style={{
                        width: screenSize - 120 + "px",
                        margin: "0px auto 15px auto",
                      }}
                    >
                      <Table
                        className="customTable"
                        rowKey={(record: any, index: any) =>
                          record.id || record.key || index
                        }
                        columns={
                          configColumns({
                            OriginalData,
                            materialData,
                            mode,
                          }) as any
                        }
                        dataSource={materialData}
                        scroll={{
                          x: "max-content",
                        }}
                        expandable={{
                          expandedRowRender: (record: any) => {
                            if (record?.key == "lastRow") {
                              return <></>;
                            }
                            return (
                              <div className="expandableBody">
                                <div style={{ flex: 1, textAlign: "left" }}>
                                  <p style={{ margin: 0 }}>
                                    {record.description}
                                  </p>
                                  {record.attachment && (
                                    <div>
                                      <PaperClipOutlined /> &nbsp;
                                      {record?.file[0]?.name ? (
                                        <a
                                          href={URL.createObjectURL(
                                            record.file[0]
                                          )}
                                          download={record.file[0]?.name}
                                        >
                                          {record.file[0]?.name}
                                        </a>
                                      ) : (
                                        <a
                                          href={record?.file?.filePath}
                                          download={record?.file?.filePath}
                                          target="_blank"
                                        >
                                          {record?.file?.fileName}
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </div>
                                {materialData?.deliveryAddressType ===
                                  "Line Level" &&
                                  record.deliveryAddressId && (
                                    <div
                                      className="lineAddress"
                                      style={{ flex: 1 }}
                                    >
                                      <h6>Delivery Address</h6>
                                      <ShowAddressPopOver
                                        id={record.deliveryAddressId}
                                      />
                                    </div>
                                  )}
                              </div>
                            );
                          },
                        }}
                        locale={{
                          emptyText: (
                            <span
                              style={{
                                height: "300px",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              {OriginalData?.tenderFor === "Material"
                                ? "There Is No Material"
                                : "There Is No Task"}
                            </span>
                          ),
                        }}
                        bordered
                        size="middle"
                        pagination={{
                          current: itemsCurrentPage,
                          pageSize: itemsPageSize,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100"],
                          showTotal: (total, range) =>
                            `${range[0]}-${range[1]} of ${total} items`,
                          onChange: (page, size) => {
                            setItemsCurrentPage(page);
                            setItemsPageSize(size);
                          },
                        }}
                      />
                    </div>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>Information for Evaluation</>
                    </div>
                  }
                  key="3"
                >
                  <FormProvider {...methods}>
                    <form className="content clearfix mt-0 ps-1">
                      {TabsList?.length > 0 && (
                        <div className="d-flex align-items-center flex-wrap mb-2 mt-0">
                          <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative ">
                            {TabsList?.map((_tab: any, index: number) => {
                              return (
                                <li
                                  className="nav-item"
                                  key={_tab?.tabKey}
                                  onClick={() =>
                                    setActiveTab(() => _tab?.tabKey)
                                  }
                                >
                                  <a
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                    }}
                                    className={`nav-link${
                                      activeTab === _tab?.tabKey
                                        ? " active"
                                        : ""
                                    }`}
                                    href={"#" + _tab?.tabKey}
                                  >
                                    {_tab?.label}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                          <div className="tab-content mt-2 w-100">
                            {Object.keys(questioners)?.map(
                              (questionerSectionId: string) => {
                                const questioner =
                                  questioners?.[questionerSectionId];
                                console.log("questioner", questioner);
                                const { questions } = questioner;
                                return (
                                  <div
                                    key={questionerSectionId}
                                    className={`tab-pane${
                                      activeTab == questionerSectionId
                                        ? " active"
                                        : " "
                                    }`}
                                  >
                                    <Descriptions
                                      title={undefined}
                                      className="custom-description-title ps-1"
                                    >
                                      <Descriptions.Item label="Section Evaluators">
                                        <SectionApprovalsContent
                                          OriginalData={questioner}
                                        />
                                      </Descriptions.Item>
                                    </Descriptions>
                                    <Table
                                      className="customTable"
                                      columns={[
                                        {
                                          title: "Question",
                                          dataIndex: "description",
                                          key: "description",
                                          // width: 450,
                                          render: (
                                            description: any,
                                            record: any
                                          ) => {
                                            return (
                                              <div>
                                                <span>
                                                  {description}{" "}
                                                  {record.mandatory && (
                                                    <span className="mandatory">
                                                      *
                                                    </span>
                                                  )}
                                                </span>
                                              </div>
                                            );
                                          },
                                        },
                                        {
                                          title: "Question Type",
                                          dataIndex: "type",
                                          key: "type",
                                          width: 150,
                                          render: (type: any) => {
                                            const config =
                                              typeConfigMap[type] || {};
                                            return (
                                              <Tag
                                                color={config.color}
                                                icon={config.icon}
                                              >
                                                {type}
                                              </Tag>
                                            );
                                          },
                                        },
                                        {
                                          title: "Weightage",
                                          dataIndex: "weightage",
                                          key: "weightage",
                                          width: 80,
                                          render: (weightage: any) => {
                                            return (
                                              <div>
                                                <span>{weightage} %</span>
                                              </div>
                                            );
                                          },
                                        },
                                      ]}
                                      dataSource={questions}
                                      pagination={false}
                                      bordered
                                      rowKey="key"
                                      expandable={expandableConfig}
                                      locale={{
                                        emptyText: (
                                          <>
                                            <Empty
                                              image={
                                                Empty.PRESENTED_IMAGE_SIMPLE
                                              }
                                              description={
                                                <>
                                                  <strong>
                                                    No Questions Found, Please
                                                    Skip this Section
                                                  </strong>
                                                </>
                                              }
                                            />
                                          </>
                                        ),
                                      }}
                                    />
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      )}
                    </form>
                  </FormProvider>
                </Panel>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>Others</>
                    </div>
                  }
                  key="4"
                >
                  <Descriptions title="" className="custom-description-title">
                    <Descriptions.Item label="Instructions">
                      <span
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setInstructionsVisible(true)}
                      >
                        View
                      </span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Terms and Conditions">
                      <span
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setTermsVisible(true)}
                      >
                        View
                      </span>
                    </Descriptions.Item>

                    <Descriptions.Item label="">
                      <div>
                        <strong
                          className=""
                          style={{
                            display: "flex",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Attachments &nbsp; <PaperClipOutlined />
                        </strong>
                        {attachments && attachments.length > 0 ? (
                          <div>
                            {attachments.map((doc: any, index: number) => (
                              <div
                                key={doc.docId || index}
                                className="w-100 d-flex justify-content-between"
                              >
                                <div>
                                  <strong>{index + 1}.</strong>&nbsp;
                                  {doc.fileName || `Document ${index + 1}`}
                                </div>
                                {doc.filePath && (
                                  <div>
                                    <a
                                      href={doc.filePath}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ color: "black", fontSize: "18px" }}
                                    >
                                      <DownloadOutlined />
                                    </a>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div> N/A</div>
                        )}
                      </div>
                    </Descriptions.Item>
                  </Descriptions>
                </Panel>
              </AntCollapse>

              <AntModal
                title="Instructions"
                open={instructionsVisible}
                footer={null}
                onCancel={() => setInstructionsVisible(false)}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                {instructions ? (
                  <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: instructions }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty description="No instructions provided for this Tender" />
                  </div>
                )}
              </AntModal>

              <AntModal
                title="Terms and Conditions"
                open={termsVisible}
                footer={null}
                onCancel={() => setTermsVisible(false)}
                width="60%"
                styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
              >
                {termsAndConditions ? (
                  <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: termsAndConditions }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty description="No terms and conditions provided for this Tender" />
                  </div>
                )}
              </AntModal>
            </div>
          </div>
        </Card>
      </Content>

      {/* Notes Drawer */}
      <Drawer
        title="Tender Notes"
        placement="right"
        width={480}
        open={notesDrawerOpen}
        onClose={() => setNotesDrawerOpen(false)}
        footer={
          <div style={{ display: "flex", gap: 8 }}>
            <Input.TextArea
              rows={2}
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder="Add a note..."
              style={{ flex: 1 }}
            />
            <AntButton
              type="primary"
              disabled={!newNote.trim()}
              onClick={() => {
                if (!newNote.trim()) return;
                setNotes((prev) => [
                  {
                    text: newNote.trim(),
                    date: dayjs().format("YYYY-MM-DD hh:mm A"),
                    user: currentUser?.name || "Current User",
                  },
                  ...prev,
                ]);
                setNewNote("");
              }}
              style={{ height: "auto" }}
            >
              Add
            </AntButton>
          </div>
        }
      >
        {notes.length === 0 ? (
          <Empty description="No notes yet" />
        ) : (
          <Timeline
            items={notes.map((note, idx) => ({
              color: idx === 0 ? "blue" : "gray",
              children: (
                <div key={idx}>
                  <div
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      marginBottom: 4,
                    }}
                  >
                    {note.text}
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>
                    <span style={{ marginRight: 12 }}>
                      <ClockCircleOutlined style={{ marginRight: 4 }} />
                      {note.date}
                    </span>
                    <span>by {note.user}</span>
                  </div>
                </div>
              ),
            }))}
          />
        )}
      </Drawer>
    </>
  );
};

const RejectPo = ({ isModalVisible, setIsModalVisible, rejectTender }: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        rejectTender(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <AntModal
      title="Reject Tender"
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Submit"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[{ required: true, message: "Please input your reason!" }]}
        >
          <Input.TextArea placeholder="Type your reason here..." />
        </Form.Item>
      </Form>
    </AntModal>
  );
};

const ApprovalPopover: React.FC<{
  approvals: any[];
  hasAccess: boolean;
}> = ({ approvals, hasAccess }) => (
  <div>
    <div
      style={{
        color: "#2263b3",
        fontWeight: 600,
        fontSize: 18,
        marginBottom: 8,
      }}
    >
      Approval Hierarchy
    </div>
    <div style={{ position: "relative", paddingLeft: 28 }}>
      {approvals.map((a, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: i !== approvals.length - 1 ? 18 : 0,
            position: "relative",
            minHeight: 64, // Ensures enough space for the line
          }}
        >
          {/* Icon and vertical line */}
          <div
            style={{
              position: "relative",
              marginRight: 8,
              width: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <span style={{ zIndex: 1 }}>
              {hasAccess ? (
                <CheckCircleTwoTone
                  twoToneColor="#52c41a"
                  style={{ fontSize: 20, marginTop: 2 }}
                />
              ) : i === 0 ? (
                <CheckCircleTwoTone
                  twoToneColor="#52c41a"
                  style={{ fontSize: 20, marginTop: 2 }}
                />
              ) : (
                <CloseCircleTwoTone
                  twoToneColor="#ff4d4f"
                  style={{ fontSize: 20, marginTop: 2 }}
                />
              )}
            </span>
            {/* Vertical line except for last item */}
            {i !== approvals.length - 1 && (
              <div
                style={{
                  position: "absolute",
                  top: 30,
                  left: "50%",
                  width: 2,
                  height: 70,
                  background: "#e0e0e0",
                  transform: "translateX(-50%)",
                  zIndex: 0,
                }}
              />
            )}
          </div>
          {/* Details */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 0,
              minWidth: 120,
            }}
          >
            <span style={{ fontWeight: 600, fontSize: 15, color: "#222" }}>
              {a.name}
            </span>
            <span style={{ fontSize: 13, color: "#666", marginTop: 0 }}>
              {a.role}
            </span>
            <span style={{ fontSize: 13, color: "#666", marginTop: 0 }}>
              {a.type}
            </span>
            <span style={{ fontSize: 13, color: "#666", marginTop: 0 }}>
              {dayjs(a.dateTime, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
                "DD-MMM-YYYY"
              )}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);
export default ViewTenderDetails;
